/**
 * VendorProductCategoryService
 * Service for managing vendor product categories
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product category CRUD operations
 */
export class VendorProductCategoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductCategoryService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductCategoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorProductCategoryService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductCategoryService.BASE_PATH = 'api/vendor-product-categories';
//# sourceMappingURL=VendorProductCategoryService.js.map